// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"ffa39375","453":"4307a5c1"}[chunkId] + ".chunk.js";
};